export enum CashSettlValuationMethod {
  /** Market */
  Market = 0,
  /** Highest */
  Highest = 1,
  /** Average market */
  AverageMarket = 2,
  /** Average highest */
  AverageHighest = 3,
  /** Blended market */
  BlendedMarket = 4,
  /** Blended highest */
  BlendedHighest = 5,
  /** Average blended market */
  AverageBlendedMarket = 6,
  /** Average blended highest */
  AverageBlendedHighest = 7,
}
